import type { Logger } from '../logger';

/**
 * @name ConsoleLogger
 * @description A browser-safe logger implementation using console
 */
const ConsoleLogger: Logger = {
  info: (...args: unknown[]) => {
    console.info(...args);
  },
  error: (...args: unknown[]) => {
    console.error(...args);
  },
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },
  debug: (...args: unknown[]) => {
    console.debug(...args);
  },
  fatal: (...args: unknown[]) => {
    console.error('[FATAL]', ...args);
  },
};

export { ConsoleLogger };
